import React    from 'react';

import mapboxgl from 'mapbox-gl';
mapboxgl.accessToken = 'pk.eyJ1IjoidGhlc2FtcCIsImEiOiJjazd6MG95Z2swMWFrM2RydTh1YWNyNTc1In0.-AEzkgZIPbJN0d3XnFg38A';


class Where extends React.Component{

    _mapRef = React.createRef();
    _markRef = React.createRef();
    _destMarkRef = React.createRef();
    _taskResultsRef = React.createRef();

    _map = {};
    _mark = null;
    _destMark = null;

    _distanceTo = null;

    _error = false;

    _newcenter = [0, 25];


    componentDidMount(){

        this._map = new mapboxgl.Map({
            container: this._mapRef.current,
            style: 'mapbox://styles/mapbox/satellite-streets-v11',//'mapbox://styles/thesamp/ck7z0c0dc0pnl1ipkger832we',
            center: this._newcenter,
            zoom: 1.5
        });
        
        this._map.on('load', ()=>{
            this._map.on('click', this.setMarker);
        });

        /*this._map.on('locationerror', function() {
            this._error = true;
        });*/

        /*map.flyTo({
            center: [
                24,
                60
            ],
            zoom: this.state.zoom,
            essential: true // this animation is considered essential with respect to prefers-reduced-motion
        });*/

        /*map.on('move', () => {
            this.setState({
                lng: map.getCenter().lng.toFixed(4),
                lat: map.getCenter().lat.toFixed(4),
                zoom: map.getZoom().toFixed(2)
            });
        });*/
    }


    setMarker =(evt)=>{        

            if(!this._markRef.current.classList.contains('g-hide') && !this._destMarkRef.current.classList.contains('g-hide')){
                return;
            }

            if(!evt.lngLat || !this.props.task.loc){
                alert('Too soon! Wait for the map to load first.');
                return;
            }

        this.props.task.loc['lng'] = this.props.task.loc.lon;
        delete this.props.task.loc.lon; 

        this.props.pointOfNoReturn();
        this._mark = new mapboxgl.Marker(this._markRef.current)
        .setLngLat(evt.lngLat)
        .addTo(this._map);

        this._markRef.current.classList.remove('g-hide');
        this.setDestMarker();
        this.setDistance();
        this.AddDistanceLine([evt.lngLat.lng, evt.lngLat.lat], [this.props.task.loc.lng, this.props.task.loc.lat]);
    }


    setDestMarker =()=> {
        this._destMark = new mapboxgl.Marker(this._destMarkRef.current)
        .setLngLat(this.props.task.loc)
        .addTo(this._map);
        this._destMarkRef.current.classList.remove('g-hide');
        this._map.resize();
    }

    
    AddDistanceLine =(start, end)=>{

        this._map.addSource('route', {
                'type': 'geojson',
                'data': {
                    'type': 'Feature',
                    'properties': {},
                    'geometry': {
                    'type': 'LineString',
                    'coordinates': [
                        start,
                        end
                    ]
                }
            }
        });

        this._map.addLayer({
            'id': 'routelayer',
            'type': 'line',
            'source': 'route',
            'layout': {
            'line-join': 'round',
            'line-cap': 'round'
            },
            'paint': {
                'line-color': '#F6921E',
                'line-width': 6
            }
        });        
    }


    componentDidUpdate(){

            if(!this.props.ui_locked){
                this._taskResultsRef.current.innerHTML =  '';

                this._markRef.current.classList.add('g-hide');
                this._destMarkRef.current.classList.add('g-hide');

                    if (this._map.getLayer('routelayer')) {
                        this._map.removeLayer('routelayer');
                    }

                    if (this._map.getSource('route')) {
                        this._map.removeSource('route');
                    }
               
                this._mapRef.current.classList.remove('half-height');
                this._taskResultsRef.current.classList.add('g-hide');
            }

            if(this.props.classes === 'g-view-in' || this.props.task_ended){
                this._map.resize();
                this._map.setZoom(1.5);
            }
    }


    setDistance =()=>{

        const bounds = [
            [parseFloat(this.props.task.loc.lng), parseFloat(this.props.task.loc.lat)],
            [this._mark._lngLat.lng, this._mark._lngLat.lat]
        ];

        const pnt_start = new mapboxgl.LngLat(bounds[0][0], bounds[0][1]);
        const pnt_end = new mapboxgl.LngLat(bounds[1][0], bounds[1][1]);

        this._distanceTo = Math.round(pnt_start.distanceTo(pnt_end));
        this._taskResultsRef.current.classList.remove('g-hide');
        let displayDistance = (this._distanceTo/1000).toFixed(2) + 'km';

            if(this._distanceTo < 1000) displayDistance = this._distanceTo + 'm';
            
        const pts = ((this.props.points_max) - (this._distanceTo/1000)).toFixed();//change to km's with 1000

        this._taskResultsRef.current.innerHTML = '<div><h2>' + this.props.task.title + '</h2><div id="whereResultsDistance"><h2>Distance</h2><h2>' + displayDistance + '</h2></div><div class="g-divider-xs"></div><h2>Points: ' + pts + ' of ' + this.props.points_max + '</h2></div>';
        
        this.props.updatePoints(pts);
        this._map.resize();
        this._map.fitBounds(bounds, {padding: 75});
    }


    render(){

        return(
            <section id="taskContainer" className={(this.props.task_ended ? ' page-content ' : ' content ') + this.props.classes}>

                <div id="mapbox" ref={this._mapRef} className={(this.props.task_ended ? 'half-height' : '')}>
                    <div id="opMapDestMark" ref={this._destMarkRef} className="map-marker g-hide"><div><i className="material-icons">radio_button_checked</i></div></div>
                    <div id="opMapMark" ref={this._markRef} className="map-marker g-hide"><div><i className="material-icons">person</i></div></div>
                </div>

                <div id="taskResults" ref={this._taskResultsRef} className="g-hide">
                    <div><h2>Distance: <span>0</span></h2></div>
                    <div><h2>Points: <span>0</span></h2></div>
               </div>

                <div className={(this.props.task_ended ? 'g-hide' : 'ui-guide-message ui-guide-message-simple')}><span>Click on map!</span></div>

            </section>
        )
    }
}

export default Where;